import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

interface Props {
  open: boolean;
}

const LoaderBackdrop: React.FC<Props> = ({ open }) => {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: "rgba(0, 0, 0, 0.3)",
      }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default LoaderBackdrop;
